import { Component } from "react";
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import HeaderSistema from "./components/HeaderSistema";
import Constante from "../../util/Constante";
import Util from "../../util/Util";
import Pessoa from "lirida-back-service/Servicos/Pessoa/Pessoa";
import PessoaService from "lirida-back-service/Servicos/Pessoa/PessoaService";
import Pesquisa from "lirida-back-service/Servicos/Pesquisa/Pesquisa";

export default class Profissionais extends Component {
  util = new Util();
  constante = new Constante();
  pessoaService = new PessoaService(this.constante.token, this.constante.url_base);

  state = {
    pessoaUsuario: new Pessoa(),
    listaProfissional: [],
    carregando: false,
    filtro: {
      seqPerfil: '',
      nomeResponsavel: '',
      nome: '',
      dataCadastroInicial: '',
      dataCadastroFinal: '',
    }
  }

  componentDidMount() {
    this.iniciar();
  }


  async iniciar() {
    let pessoaUsuario = await this.util.buscarLocalStorage("PESSOA_USUARIO");
    this.listar();
    this.setState({
      pessoaUsuario: pessoaUsuario
    })
  }

  async listar() {
    this.setState({ carregando: true });
    const listaPesquisa = [];

    let pesquisa = new Pesquisa();
    pesquisa.campo = 'pessoa.seq_usuario';
    pesquisa.conteudo = this.constante.seqUsuario;
    pesquisa.operacao = '';
    pesquisa.tipo = 'TEXTO';
    listaPesquisa.push(pesquisa);


    if (!this.state.filtro.seqPerfil) {
      pesquisa = new Pesquisa();
      pesquisa.campo = " AND pessoa.seq_pessoa_perfil in ('" + this.constante.seqPessoaPerfilFaxineiro + "', '" + this.constante.seqPessoaPerfilLider + "') "
      pesquisa.conteudo = this.constante.seqPessoaPerfilFaxineiro;
      pesquisa.operacao = 'AND';
      pesquisa.tipo = 'MANUAL';
      listaPesquisa.push(pesquisa);
    }

    if (this.state?.filtro?.seqPerfil) {
      pesquisa = new Pesquisa();
      pesquisa.campo = 'pessoa.seq_pessoa_perfil';
      pesquisa.conteudo = this.state?.filtro?.seqPerfil;
      pesquisa.operacao = 'AND';
      pesquisa.tipo = 'TEXTO';
      listaPesquisa.push(pesquisa);
    }

    if (this.state?.filtro?.nome) {
      pesquisa = new Pesquisa();
      pesquisa.campo = 'pessoa.nome';
      pesquisa.conteudo = this.state?.filtro?.nome;
      pesquisa.operacao = 'AND';
      pesquisa.tipo = 'TEXTO';
      listaPesquisa.push(pesquisa);
    }


    if (this.state?.filtro?.nomeResponsavel) {
      pesquisa = new Pesquisa();
      pesquisa.campo = 'pessoa.responsavel_nome';
      pesquisa.conteudo = this.state?.filtro?.nomeResponsavel;
      pesquisa.operacao = 'AND';
      pesquisa.tipo = 'TEXTO';
      listaPesquisa.push(pesquisa);
    }

    if (this.state.filtro.dataCadastroInicial) {
      pesquisa = new Pesquisa();
      pesquisa.campo = "pessoa.data_cadastro";
      pesquisa.conteudo = this.util.formatarDataBanco(this.state.filtro.dataCadastroInicial);
      pesquisa.operacao = "AND";
      pesquisa.tipo = "DATA_INICIAL";
      listaPesquisa.push(pesquisa);
    }

    if (this.state.filtro.dataCadastroFinal) {
      pesquisa = new Pesquisa();
      pesquisa.campo = "pessoa.data_cadastro";
      pesquisa.conteudo = this.util.formatarDataBanco(this.state.filtro.dataCadastroFinal);
      pesquisa.operacao = "AND";
      pesquisa.tipo = "DATA_FINAL";
      listaPesquisa.push(pesquisa);
    }

    let retorno = await this.pessoaService.listarComFiltro(listaPesquisa);
    let listaProfissional = retorno.objeto
    console.log(listaProfissional);
    this.setState({
      listaProfissional: listaProfissional,
      carregando: false,
    })
    return
  }
  render() {
    return <div>
      <HeaderSistema />
      <main style={{ width: "98%", margin: "20px auto" }}>
        <div
          style={{
            border: "1px solid lightgray",
            padding: 20,
            borderRadius: 3,
          }}
        >
          <h1 style={{ fontSize: 22, margin: 0 }}>Profissionais</h1>
          <h2 style={{ fontSize: 20, color: 'gray', margin: 0 }}>Profissionais</h2>
        </div>

        {/* FILTRO */}
        <div style={{ border: '1px solid lightgray', padding: 10, borderRadius: 3, gap: 20, marginTop: 20 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 20 }}>
            <div>
              <label>Nome</label><br />
              <InputText
                onChange={pTexto => this.setState({
                  filtro: {
                    ...this.state.filtro, nome: pTexto.target.value
                  }
                })}
                value={this.state.filtro.nome || ''}
                placeholder="Nome"
                style={{ width: '100%', height: 40 }}
              />
            </div>

            <div>
              <label>Nome responsável</label><br />
              <InputText
                onChange={pTexto => this.setState({
                  filtro: {
                    ...this.state.filtro, nomeResponsavel: pTexto.target.value
                  }
                })}
                value={this.state.filtro.nomeResponsavel || ''}
                placeholder="Nome responsável"
                style={{ width: '100%', height: 40 }}
              />
            </div>

            <div>
              <label>Perfil</label><br />
              <Dropdown
                onChange={pItem => this.setState({
                  filtro: {
                    ...this.state.filtro, seqPerfil: pItem.value
                  }
                })}
                value={this.state.filtro.seqPerfil}
                options={[{ nome: "Todos", value: "" }, { nome: "Líder", value: this.constante.seqPessoaPerfilLider }, { nome: "Faxineiro", value: this.constante.seqPessoaPerfilFaxineiro }]}
                optionLabel='nome'
                optionValue="value"
                placeholder='Selecione'
                style={{
                  width: "100%",
                  height: 40,
                }}
              />
            </div>


            <div>
              <label>Data cadastro inicial</label><br />
              <Calendar
                onChange={(pTexto) => this.setState({
                  filtro: {
                    ...this.state.filtro, dataCadastroInicial: pTexto.target.value
                  }
                })}
                showButtonBar
                style={{ width: "100%", height: 40 }}
                dateFormat="dd/mm/yy"
                placeholder="dd/mm/yyyy"
              />
            </div>

            <div>
              <label>Data cadastro final</label><br />
              <Calendar
                onChange={(pTexto) => this.setState({
                  filtro: {
                    ...this.state.filtro, dataCadastroFinal: pTexto.target.value
                  }
                })}
                showButtonBar
                style={{ width: "100%", height: 40 }}
                dateFormat="dd/mm/yy"
                placeholder="dd/mm/yyyy"
              />
            </div>
          </div>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
            <Button loading={this.state.carregando} label="Buscar" className="p-button-raised"
              onClick={() => this.listar()} style={{ backgroundColor: this.constante.corPrincipal, borderColor: this.constante.corPrincipal }}
            />
          </div>

        </div>
        {/* FIM FILTRO */}


        {/* TABELA */}

        <DataTable
          showGridlines
          removableSort
          paginator
          responsiveLayout="scroll"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
          rows={50}
          rowsPerPageOptions={[50, 60, 70, 80, 100]}
          style={{ width: "100%", marginTop: 30 }}
          value={this.state.listaProfissional}
          loading={this.state.carregando}
        >
          <Column header='Razão social'
            field='nome'
            sortable
            body={pItem => <a href={`/sistema/profissional_detalhe?id=${pItem._seqPessoa}`}>{pItem.nome}</a>}
          />

          <Column header='Nome fantasia'
            field='apelido'
            sortable
          />

          <Column header='Perfil'
            field='_perfilNome'
            sortable
          />

          <Column header='Data cadastro'
            field='dataCadastro'
            sortable
            body={pItem => <p>{this.util.formatarData(pItem.dataCadastro)}</p>}
          />
        </DataTable>

        {/* FIM DA TABELA */}

      </main>
    </div>
  }
}